import React from 'react';

const AdminRosterTeam = () => {
  return <div></div>;
};

export default AdminRosterTeam;
